import { isValidPhoneNumber } from "react-phone-number-input"
import { t } from "i18next"
import { isValidEmail } from "utils"

export const getEmailRules = (required = true) => [
  {
    validator: async (_, value) => {
      if (!value) 
        return required
        ? Promise.reject(new Error(t("Email is required")))
        : Promise.resolve()
      if (!isValidEmail(value)) return Promise.reject(new Error(t("Invalid email format")))
      return Promise.resolve()
    },
  },
]

export const getPhoneRules = (required = true) => [
  {
    validator: async (_, value) => {
      if (!value ) 
        return required
        ? Promise.reject(new Error(t("Phone number is required")))
        : Promise.resolve()
      if (!isValidPhoneNumber(value)) return Promise.reject(new Error(t("Invalid phone number")))
      return Promise.resolve()
    },
  },
]
